module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "galley"
  }, [_c('p', [_c('a', {
    attrs: {
      "id": "page_normal--num_vi--seq_6"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_normal--num_vi--seq_6"
    }
  }, [_c('div', {
    staticClass: "title-block",
    attrs: {
      "id": "section-chapter--num_vi--seq_vi"
    }
  }, [_c('h1', [_vm._v("TABLE OF CONTENTS")])]), _vm._v(" "), _c('div', {
    staticClass: "list-toc"
  }, [_c('table', {
    staticClass: "toc",
    attrs: {
      "summary": ""
    }
  }, [_c('tbody', [_c('tr', [_c('td', [_c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "href": "#/a9781847673749_chapter_01"
    }
  }, [_c('i', [_vm._v("Introduction")])])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tocp"
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "toc-part"
  }, [_c('a', {
    attrs: {
      "href": "#/a9781847673749_part_01"
    }
  }, [_vm._v("BOOK THREE")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tocp"
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "toc-chapter"
  }, [_c('a', {
    attrs: {
      "href": "#/a9781847673749_chapter_02"
    }
  }, [_vm._v("CHAPTER 1: The Elite")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tocp"
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "toc-chapter"
  }, [_c('a', {
    attrs: {
      "href": "#/a9781847673749_chapter_03"
    }
  }, [_vm._v("CHAPTER 2: Dawn and Lodgings")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tocp"
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "toc-chapter"
  }, [_c('a', {
    attrs: {
      "href": "#/a9781847673749_chapter_04"
    }
  }, [_vm._v("CHAPTER 3: Manuscript")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tocp"
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "toc-chapter"
  }, [_c('a', {
    attrs: {
      "href": "#/a9781847673749_chapter_05"
    }
  }, [_vm._v("CHAPTER 4: A Party")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tocp"
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "toc-chapter"
  }, [_c('a', {
    attrs: {
      "href": "#/a9781847673749_chapter_06"
    }
  }, [_vm._v("CHAPTER  5: Rima")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tocp"
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "toc-chapter"
  }, [_c('a', {
    attrs: {
      "href": "#/a9781847673749_chapter_07"
    }
  }, [_vm._v("CHAPTER 6: Mouths")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tocp"
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "toc-chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/a9781847673749_chapter_08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 7: The Institute ")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tocp"
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "toc-chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/a9781847673749_chapter_09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 8: Doctors")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tocp"
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "toc-chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/a9781847673749_chapter_10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 9: A Dragon")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tocp"
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "toc-chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/a9781847673749_chapter_11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 10: Explosions ")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tocp"
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "toc-chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/a9781847673749_chapter_12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 11: Diet and Oracle")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tocp"
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "toc-chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/a9781847673749_chapter_13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PROLOGUE "), _c('br'), _vm._v("telling how a nonentity was made, and made oracular by a financial genius discovering his sensual infancy")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tocp"
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "toc-part"
  }, [_c('span', {
    attrs: {
      "href": "#/a9781847673749_part_02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("BOOK ONE")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tocp"
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "toc-chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/a9781847673749_chapter_14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 12: The War Begins")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tocp"
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "toc-chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/a9781847673749_chapter_15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 13: A Hostel")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tocp"
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "toc-chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/a9781847673749_chapter_16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 14: Ben Rua ")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tocp"
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "toc-chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/a9781847673749_chapter_17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 15: Normal")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tocp"
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "toc-chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/a9781847673749_chapter_18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 16: Underworlds ")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tocp"
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "toc-chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/a9781847673749_chapter_19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 17: The Key")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tocp"
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "toc-chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/a9781847673749_chapter_20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 18: Nature")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tocp"
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "toc-chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/a9781847673749_chapter_21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 19: Mrs. Thaw Disappears")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tocp"
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "toc-chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/a9781847673749_chapter_22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 20: Employers")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tocp"
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "toc-chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/a9781847673749_chapter_23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("INTERLUDE "), _c('br'), _vm._v("to remind us of what we are in danger of forgetting: that Thaw’s story exists within the hull of Lanark’s ")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tocp"
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "id": "page_normal--num_vii--seq_7"
    }
  })])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tocp"
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "toc-part"
  }, [_c('span', {
    attrs: {
      "href": "#/a9781847673749_part_03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("BOOK TWO")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tocp"
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "toc-chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/a9781847673749_chapter_24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 21: The Tree ")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tocp"
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "toc-chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/a9781847673749_chapter_25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 22: Kenneth McAlpin ")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tocp"
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "toc-chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/a9781847673749_chapter_26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 23: Meetings ")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tocp"
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "toc-chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/a9781847673749_chapter_27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 24: Marjory Laidlaw ")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tocp"
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "toc-chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/a9781847673749_chapter_28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 25: Breaking ")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tocp"
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "toc-chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/a9781847673749_chapter_29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 26: Chaos ")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tocp"
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "toc-chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/a9781847673749_chapter_30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 27: Genesis ")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tocp"
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "toc-chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/a9781847673749_chapter_31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 28: Work ")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tocp"
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "toc-chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/a9781847673749_chapter_32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 29: The Way Out ")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tocp"
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "toc-chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/a9781847673749_chapter_33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 30: Surrender ")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tocp"
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "toc-part"
  }, [_c('span', {
    attrs: {
      "href": "#/a9781847673749_part_04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("BOOK FOUR")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tocp"
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "toc-chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/a9781847673749_chapter_34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 31: Nan ")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tocp"
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "toc-chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/a9781847673749_chapter_35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 32: Council Corridors ")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tocp"
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "toc-chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/a9781847673749_chapter_36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 33: A Zone ")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tocp"
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "toc-chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/a9781847673749_chapter_37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 34: Intersections ")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tocp"
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "toc-chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/a9781847673749_chapter_38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 35: Cathedral ")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tocp"
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "toc-chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/a9781847673749_chapter_39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 36: Chapterhouse ")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tocp"
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "toc-chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/a9781847673749_chapter_40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 37: Alexander Comes ")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tocp"
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "toc-chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/a9781847673749_chapter_41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 38: Greater Unthank ")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tocp"
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "toc-chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/a9781847673749_chapter_42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 39: Divorce ")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tocp"
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "toc-chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/a9781847673749_chapter_43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 40: Provan ")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tocp"
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "toc-chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/a9781847673749_epilogue",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("EPILOGUE "), _c('br'), _vm._v("annotated by Sidney Workman with an index of diffuse and imbedded Plagiarisms")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tocp"
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "toc-chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/a9781847673749_chapter_44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 41: Climax ")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tocp"
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "toc-chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/a9781847673749_chapter_45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 42: Catastrophe ")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tocp"
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "toc-chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/a9781847673749_chapter_46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 43: Explanation ")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tocp"
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "toc-chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/a9781847673749_chapter_47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 44: End ")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tocp"
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "toc-bm"
  }, [_c('span', {
    attrs: {
      "href": "#/a9781847673749_chapter_48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("TAILPIECE: How "), _c('i', [_vm._v("Lanark grew")])])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tocp"
  })])])])])])]), _c('p', [_c('a', {
    attrs: {
      "id": "page_normal--num_vi--seq_6"
    }
  }), _c('a', {
    attrs: {
      "id": "page_normal--num_viii--seq_8"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_normal--num_viii--seq_8"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_normal--num_viii--seq_8"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-61ba5b7c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/a9781847673749_tableofcontents.vue
// module id = 75
// module chunks = 0